function getColor(d) {
  if (d > 1000) {
    return "#005774";
  }
  if (d > 200) {
    return "#5cb1cd";
  }
  if (d > 25) {
    return "#89BBBB";
  }
  return "#afe1f2";
}

function style(feature, opacity = 0.6) {
  return {
    fillColor: getColor(feature.properties.broadband_access),
    weight: 2,
    opacity: 1,
    color: "white",
    dashArray: "3",
    fillOpacity: opacity,
  };
}

export default style;
